var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.3371 50.6053L82.0365 3.9232M36.6646 52.7046L47.2537 73.8833C49.8128 79.001 51.0921 81.5602 52.704 82.2463C54.1029 82.8419 55.702 82.7337 57.0084 81.9561C58.5136 81.0599 59.438 78.3521 61.2871 72.937L81.2946 14.3432C82.906 9.62498 83.7113 7.26583 83.16 5.7052C82.6802 4.34754 81.6124 3.27958 80.255 2.79992C78.694 2.24855 76.335 3.05412 71.6165 4.66521L13.0227 24.6729C7.6077 26.522 4.90015 27.4465 4.00386 28.9517C3.22603 30.258 3.11825 31.857 3.71374 33.2556C4.39995 34.8675 6.95893 36.1473 12.0769 38.7059L33.2553 49.2955C34.0988 49.7172 34.5205 49.9278 34.8854 50.2094C35.2099 50.4595 35.5006 50.7501 35.7502 51.0741C36.0323 51.4396 36.2429 51.8613 36.6646 52.7046Z",
    stroke: "url(#paint0_linear_256_20036)",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_256_20036",
    x1: 3.33301,
    y1: 42.627,
    x2: 83.3329,
    y2: 42.627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02E3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA05D3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.4f42e95733f27be6cf3be6d66c6d4c8f.svg";
export { ForwardRef as ReactComponent };